import React, { useState, useEffect } from 'react';

const QuickCount = ({ limit = 2000 }) => {
    const [count, setCount] = useState(0);
    const [running, setRunning] = useState(true);

    const incrementCount = () => {
        setCount((prevCount) => {
        if (prevCount >= limit) {
            setRunning(false); 
            return limit;
        }
        return prevCount + 1;
        });
        if (running) {
        requestAnimationFrame(incrementCount); 
        }
    };

  useEffect(() => {
    if (running) {
      requestAnimationFrame(incrementCount); 
    }

    return () => setRunning(false);
  }, [running]);

  return (
    <div style={{ fontSize: '70px', textAlign: 'center' }}>
      {count}
    </div>
  );
};

export default QuickCount;